import React from 'react';
import styles from './CheckinConfigSelector.styles';
import { InputNumber, Select } from 'antd';

const { Option } = Select;

export default function CheckinConfigSelector({
  configOption,
  title,
  description,
  initialValue,
  setValue,
  options,
  value,
  disabled,
  hotel,
  disabledList,
  pmsName,
}) {
  if (disabledList) {
    if (disabledList.includes(configOption)) {
      disabled = true;
    }
  }

  const hidePmsNamesFields = ['show_multibooking_holders', 'show_booking_guests'];
  const pmsAvailableForPmsNamesCapture = ['Tecsoft', 'Sihot360', 'Winhotel'];

  if (
    hidePmsNamesFields.includes(configOption) &&
    !pmsAvailableForPmsNamesCapture.includes(pmsName)
  ) {
    return null;
  }

  return (
    <div>
      <b style={styles.header}>{title}</b>
      <div style={styles.container}>
        {Array.isArray(options) ? (
          <Select
            key={`${configOption}_${hotel?.key}`}
            onChange={option => setValue(configOption, option)}
            value={initialValue}
            style={styles.input}
            bordered={false}
            disabled={disabled}
          >
            {options?.map((option, index) => {
              return (
                <Option key={index} value={option?.key}>
                  {option?.literal || option?.key}
                </Option>
              );
            })}
          </Select>
        ) : (
          <div style={styles.inputContainer}>
            <InputNumber
              style={styles.input}
              bordered={false}
              value={value || 0}
              min={0}
              disabled={disabled}
              onChange={value => {
                setValue(configOption, value);
              }}
            />
          </div>
        )}
      </div>
      {description && !description.includes('checkinConfig') && <div>{description}</div>}
    </div>
  );
}
